import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { useFormStatus } from 'react-hooks-form';
import BaseAlert from 'packages/ui/Alert';
import $ from 'helpers/utils/mQuery';

const Alert = styled(BaseAlert)`
  margin-bottom: 20px;
`;

function Errors() {
  const { error, submitFailed, submitting } = useFormStatus();

  const ref = useRef();

  useEffect(() => {
    if (!submitting && submitFailed && error && !$(ref.current).isInViewportFromTop()) {
      $.scrollTo(ref.current, 100, 50);
    }
  }, [submitFailed, submitting]);

  if (submitFailed && error) {
    return (
      <div ref={ref}>
        <Alert mood="error" title={error.message}>
          {error.errors ? (
            <ul>
              {Object.values(error.errors).map((fieldErrors, key) => (
                <li key={key}>{fieldErrors[0]}</li>
              ))}
            </ul>
          ) : null}
        </Alert>
      </div>
    );
  }

  return null;
}

export default Errors;
